import { gql } from "@apollo/client";

// Slim list/card fragment. `identity` and `contactList` are JSONObject
// scalars the cards and contact panels read directly; `details` is the
// heavyweight bag (GIS payloads, files, enrichment) and is only fetched
// for the selected property via GET_PROPERTY_ASSET.
export const PROPERTY_CARD_FIELDS = gql`
  fragment PropertyCardFields on PropertyAsset {
    id
    name
    domain
    authorId
    category
    status
    state
    geolocation {
      latitude
      longitude
    }
    identity
    contactList
    updatedAt
    createdAt
  }
`;

export const PROPERTY_FULL_FIELDS = gql`
  fragment PropertyFullFields on PropertyAsset {
    id
    name
    domain
    authorId
    schemaType
    category
    status
    state
    geolocation {
      latitude
      longitude
    }
    identity
    details
    ref
    contactList
    updatedAt
    createdAt
  }
`;

export const GET_PROPERTY_ASSET = gql`
  query GetPropertyAsset($id: ID!) {
    propertyAsset(id: $id) {
      ...PropertyFullFields
    }
  }
  ${PROPERTY_FULL_FIELDS}
`;

export const GET_PROPERTY_ASSET_STATE_COUNTS = gql`
  query GetPropertyAssetStateCounts($input: PropertyAssetStateCountsInput!) {
    propertyAssetStateCounts(input: $input) {
      state
      count
    }
  }
`;

export const GET_PROPERTY_ASSETS = gql`
  query GetPropertyAssets($input: PropertyAssetsInput!) {
    propertyAssets(input: $input) {
      total
      propertyAssets {
        ...PropertyCardFields
      }
    }
  }
  ${PROPERTY_CARD_FIELDS}
`;
